import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import AppShell from "@/components/AppShell";
import Dashboard from "@/pages/Dashboard";
import Vehicles from "@/pages/Vehicles";
import DailyEntry from "@/pages/DailyEntry";
import Savings from "@/pages/Savings";
import Reports from "@/pages/Reports";
import Expenses from "@/pages/Expenses";
import BulkImport from "@/pages/BulkImport";
import Notes from "@/pages/Notes";
import Investments from "@/pages/Investments";
import MetricLedger, {
  SALES_CFG,
  DEPOSIT_CFG,
  EARNINGS_CFG,
  PROFIT_CFG,
  EXTRA_INCOME_CFG,
} from "@/pages/MetricLedger";
import Login from "@/auth/Login";
import AuthCallback from "@/auth/AuthCallback";
import ProtectedRoute from "@/auth/ProtectedRoute";
import { AuthProvider } from "@/auth/AuthProvider";
import { Toaster } from "sonner";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: synchronous detection of session_id in URL fragment.
  // useEffect runs AFTER render — too late, causes race conditions.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppShell>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/vehicles" element={<Vehicles />} />
                <Route path="/daily-entry" element={<DailyEntry />} />
                <Route path="/sales" element={<MetricLedger config={SALES_CFG} />} />
                <Route path="/deposit" element={<MetricLedger config={DEPOSIT_CFG} />} />
                <Route path="/earnings" element={<MetricLedger config={EARNINGS_CFG} />} />
                <Route path="/extra-income" element={<MetricLedger config={EXTRA_INCOME_CFG} />} />
                <Route path="/expenses" element={<Expenses />} />
                <Route path="/profit" element={<MetricLedger config={PROFIT_CFG} />} />
                <Route path="/savings" element={<Savings />} />
                <Route path="/notes" element={<Notes />} />
                <Route path="/investments" element={<Investments />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/bulk-import" element={<BulkImport />} />
              </Routes>
            </AppShell>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
